module.exports = __webpack_public_path__ + "img/athena_carousel_02.62689b97.jpg";